import { Reducer } from 'redux';
import { ProfileActionTypes } from '../actions';
import { ProfileStoreModel, initialProfileStoreState } from '../store.model';

export const profileReducer: Reducer<ProfileStoreModel> = (
  state = initialProfileStoreState,
  action
) => {
  switch (action.type) {
    case ProfileActionTypes.STORE_USER:
      return { ...state, user: action.payload };
    case ProfileActionTypes.STORE_LOGOUT_HANDLER:
      return { ...state, logoutHandler: action.payload };
    case ProfileActionTypes.STORE_USER_PROFILE:
      return { ...state, userProfile: action.payload };
    case ProfileActionTypes.STORE_CUSTOMER_MENU:
      return { ...state, customerMenu: action.payload };
    case ProfileActionTypes.STORE_CUSTOMER_CONFIG:
      return {
        ...state,
        customerConfig: action.payload
      };
    case ProfileActionTypes.STORE_COMPANIES:
      return {
        ...state,
        companies: action.payload,
        activeCompany:
          state.activeCompany === undefined
            ? action.payload.find(x => x.default === true)
            : state.activeCompany
      };
    case ProfileActionTypes.STORE_ACTIVE_COMPANY:
      return {
        ...state,
        activeCompany: state.companies?.find(x => x.id === action.payload),
        activeCommodity: undefined
      };
    case ProfileActionTypes.STORE_BALANCE_ZONES:
      return {
        ...state,
        balanceZones: action.payload,
        activeBalanceZone:
          state.activeBalanceZone === undefined ? action.payload[0] : state.activeBalanceZone
      };
    case ProfileActionTypes.STORE_ACTIVE_BALANCE_ZONE:
      return {
        ...state,
        activeBalanceZone: state.balanceZones?.find(x => x.id === action.payload)
      };
    case ProfileActionTypes.STORE_ACTIVE_COMMODITY:
      return {
        ...state,
        activeCommodity: action.payload
      };
    default:
      return state;
  }
};
